import React from "react";
import { useDispatch } from "react-redux";
import editIcon from 'img/edit-icon-table.svg';

import { EditExternalUserSlider } from "../EditExternalUserSlider";
import StatusCircle from "components/StatusCircle";
import { Row } from "components/Layout/Grid";
import { Button } from "components/Button";
import Text from "components/Text";

import { IUser, UserRoleTypes } from "models/User";
import { SupplierProps } from "models/Supplier";
import { Visibility } from "components/Visibility";

export function modelExternalUser(user: IUser, statusInput: string | undefined, getUsers: any, suppliers: SupplierProps[]) {
  const dispatch = useDispatch();

  const model = [
    {
      label: 'Status',
      key: 'enabled',
      size: 80,
      maxSize: 80,
      Component: (data: IUser) => (
        <Row className="justify-center w-100">
          <StatusCircle value={data?.enabled || false} pending={data?.pending ?? false} />
        </Row>
      ),
    },
    { label: 'Nome', key: 'fullName' },
    { label: 'Email', key: 'email', size: 200, noFilter: true },
    {
      label: 'Fornecedor',
      key: 'supplierName',
      size: 200,
      maxSize: 200,
      noFilter: true
    },
    {
      label: 'Nível de acesso',
      key: 'acessLevel',
      size: 150,
      maxSize: 150,
      noFilter: true,
      Component: (data: IUser) => (
        <Text className="color-blue-gray" size={12} showTip>
          {data.roles ? UserRoleTypes?.[data.roles[0]] : '-'}
        </Text>
      ),
    },
    {
      label: 'Adicionado por',
      key: 'userWhoInvited.fullName',
      size: 180,
      maxSize: 180,
      noFilter: true,
      Component: (data: IUser) => (
        <Text className="color-blue-gray" size={12} showTip>
          {data.userWhoInvited?.fullName === user.fullName
            ? 'Você'
            : data.userWhoInvited?.fullName || '-'}
        </Text>
      ),
    },
    {
      label: 'Último acesso',
      key: 'lastAccess',
      type: 'date',
      size: 140,
      maxSize: 140,
      noFilter: true
    },
    {
      label: '',
      size: 40,
      maxSize: 40,
      isButton: true,
      Component: (userProp: IUser) => (
        <Visibility visible={!userProp.pending}>
          <Button
            tooltip="Editar funcionário"
            toolTipPlace="left"
            onClick={() =>
              dispatch({
                type: 'OPEN_SLIDER',
                data: {
                  title: 'Editar Usuário',
                  subtitle:
                    'Utilize os campos abaixo para alterar informações do usuário.',
                  content: EditExternalUserSlider,
                  state: { userProp, getUsers },
                  width: 40
                },
              })
            }
          >
            <img src={editIcon} alt="" />
          </Button>
        </Visibility>
      ),
    }
  ];

  return model;
}